<template>
  <div class="chart"  >
    <div></div>
    <div class="chart-head">
      {{ filedName }}
    </div>
    <div class="chart-cont">
      <!-- 主Y轴 -->
      <div class="yName">{{ yName }}</div>
      <!-- 行内 -->
      <div
        :id="`${info.chartId}`"
        :style="{ width: '100%', height: '100%' }"
      ></div>
    </div>
  </div>
</template>
<script>
import { commonBarCharts, pictorialCharts } from "@/assets/chart-JS/barCharts";
import {
  commonLineCharts,
  doubleLineCharts,
} from "@/assets/chart-JS/lineCharts";
import { commonRadarCharts } from "@/assets/chart-JS/radarCharts";
import { commonGaugeCharts } from "@/assets/chart-JS/gaugeCharts";
import { resizeEchartsByDiv } from "@/assets/utils/resizeEchartsByDiv";
import infoCode from "./infoCode.vue";
import { forEach } from "element-resize-detector/src/collection-utils";
export default {
  props: ["chartInfo"],
  components: {
    infoCode,
  },
  data() {
    return {
      info: {},
      chartIdList: [],
      timer: null, // 定时器
      yName: "单位",
      name: "",//数据得单位名称
      getDataInterval: null,
      filedName:"",//图表得名称
      xAxis: [],//图表得时间
      random: 0,//数据得value的值
      ranArr: [],//获取的的value的值push5个进去
      putInThePowderWeight: {},
      totalWeightOfLiquid:{},
      autorotationSpeed:{},//自转速度
      PowderWeightName: "",//名称
      OfLiquidName: "",
      PowderWeightData: [],
      OfLiquidData: [],
      LdData:[1,0.3,0.3],
      CnxlData:"",
    };
  },
  created(){
    this.putInThePowderWeight = this.$store.state.putInThePowderWeight;
  },
  mounted() {
    // 上级使用for循环 导致这个先执行，所以使用nextTick函数
    this.$nextTick(() => {
      this.info = this.chartInfo;
      //设备状态设置
      if(this.info.filedKey=="deviceStatus" && this.info.value=="100"){
        this.LdData = [1,0.3,0.3];
      }else if(this.info.filedKey=="deviceStatus" && this.info.value=="1"){
        this.LdData = [0.3,1,0.3];
      }else if(this.info.filedKey=="deviceStatus" && this.info.value=="10"){
        this.LdData = [0.3,0.3,1];
      }else{
        this.LdData = [0.3,0.3,0.3]
      }
      this.name = this.chartInfo.filedName;
      this.yName = this.chartInfo.filedUnit;
      //自转速度
      this.autorotationSpeed = this.$store.state.autorotationSpeed;
      //投入粉体重量
      this.putInThePowderWeight = this.$store.state.putInThePowderWeight;
      //液体总重量
      this.totalWeightOfLiquid = this.$store.state.totalWeightOfLiquid;
      //定时器每俩秒调用一次
      this.getDataInterval = setInterval(() => {
        this.info = this.chartInfo;
        this.name = this.chartInfo.filedName;
        this.yName = this.chartInfo.filedUnit;
        //投入粉体重量
        this.putInThePowderWeight = this.$store.state.putInThePowderWeight;
        //液体总重量
        this.totalWeightOfLiquid = this.$store.state.totalWeightOfLiquid;
        this.getSum();
        if(this.info.filedKey=="deviceStatus"){
            this.CnxlData  = this.info.value
      }
      }, 2000);
      this.getSum();
    });

    // 定时器
    this.timer = setInterval(() => {
      resizeEchartsByDiv(
        this.info.chartId,
        this.info.chartId,
        this.chartIdList
      );
      if (this.info.chartNumber === 0 ) {
        //柱形图加线性图
        this.barChart();
      }else if (this.info.chartNumber === 1) {
        //线型图
        this.lineChart();
      }else if (this.info.chartNumber === 2) {
        // 雷达图
        this.radarChart();
      }else if(this.info.chartNumber === 3) {
        //仪表盘
        this.gaugeChart();
      }else if(this.info.chartNumber === 4) {
        //双线图
        this.doubleLineChart();
      }else if(this.info.chartNumber === 5) {
        //象形柱状图
        this.pictorialChart();
      }
      this.random = this.info.value;
      if (this.xAxis.length >= 5) {
        this.xAxis.shift();
        this.ranArr.shift();
      }
      this.xAxis.push(this.info.time);
      this.ranArr.push(this.random);
    }, 2000);
  },
  methods: {
    getSum() {
      if ( this.putInThePowderWeight[0].filedKey == "putInThePowderWeight" && this.info.filedKey == "powderWeight") {
        this.filedName = this.putInThePowderWeight[0].filedName+"/"+this.chartInfo.filedName; 
        this.PowderWeightName = this.putInThePowderWeight[0].filedName;
        this.OfLiquidName = this.info.filedName;
        this.putInThePowderWeight.forEach((i) => {
          this.OfLiquidData.push(i.value);
        });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else if(this.totalWeightOfLiquid[0].filedKey == "totalWeightOfLiquid" && this.info.filedKey == "liquidInputWeight"){
          this.filedName =  this.chartInfo.filedName+"/"+this.totalWeightOfLiquid[0].filedName;
          this.PowderWeightName =  this.info.filedName;
          this.OfLiquidName =  this.totalWeightOfLiquid[0].filedName;
          this.totalWeightOfLiquid.forEach((i) => {
            this.OfLiquidData.push(i.value);
          });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else if(this.putInThePowderWeight[0].filedKey == "autorotationSpeed" && this.info.filedKey == "revolutionSpeed"){
          this.filedName =  this.chartInfo.filedName+"/"+this.putInThePowderWeight[0].filedName;
          this.PowderWeightName =  this.info.filedName;
          this.OfLiquidName =  this.putInThePowderWeight[0].filedName;
          this.putInThePowderWeight.forEach((i) => {
            this.OfLiquidData.push(i.value);
          });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else if(this.putInThePowderWeight[0].filedKey == "whiteSpaceWidth" && this.info.filedKey == "coatingLength"){
          this.filedName =  this.chartInfo.filedName+"/"+this.putInThePowderWeight[0].filedName;
          this.PowderWeightName =  this.info.filedName;
          this.OfLiquidName =  this.putInThePowderWeight[0].filedName;
          this.putInThePowderWeight.forEach((i) => {
            this.OfLiquidData.push(i.value);
          });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else if(this.putInThePowderWeight[0].filedKey == "B layerTemperature" && this.info.filedKey == "A layerTemperature"){
          this.filedName = this.putInThePowderWeight[0].filedName+"/"+this.chartInfo.filedName; 
          this.PowderWeightName = this.putInThePowderWeight[0].filedName;
          this.OfLiquidName = this.info.filedName;
          this.putInThePowderWeight.forEach((i) => {
          this.OfLiquidData.push(i.value);
        });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else if(this.totalWeightOfLiquid[0].filedKey == "B layerVacuumValue" && this.info.filedKey == "A layerVacuumValue"){
          this.filedName =  this.chartInfo.filedName+"/"+this.putInThePowderWeight[0].filedName;
          this.PowderWeightName =  this.info.filedName;
          this.OfLiquidName =  this.totalWeightOfLiquid[0].filedName;
          this.totalWeightOfLiquid.forEach((i) => {
            this.OfLiquidData.push(i.value);
          });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else if(this.putInThePowderWeight[0].filedKey == "weighAfterInjection" && this.info.filedKey == "weighBeforeFilling"){
          this.filedName = this.putInThePowderWeight[0].filedName+"/"+this.chartInfo.filedName; 
          this.PowderWeightName = this.putInThePowderWeight[0].filedName;
          this.OfLiquidName = this.info.filedName;
          this.putInThePowderWeight.forEach((i) => {
          this.OfLiquidData.push(i.value);
        });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else if(this.putInThePowderWeight[0].filedKey == "lowerSealingKnifeTemperature" && this.info.filedKey == "upperSealingKnifeTemperature"){
          this.filedName = this.putInThePowderWeight[0].filedName+"/"+this.chartInfo.filedName; 
          this.PowderWeightName = this.putInThePowderWeight[0].filedName;
          this.OfLiquidName = this.info.filedName;
          this.putInThePowderWeight.forEach((i) => {
          this.OfLiquidData.push(i.value);
        });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else if(this.putInThePowderWeight[0].filedKey == "CFXFDWD" && this.info.filedKey == "CFSFDWD"){
          this.filedName =  this.chartInfo.filedName+"/"+this.putInThePowderWeight[0].filedName;
          this.PowderWeightName =  this.info.filedName;
          this.OfLiquidName =  this.putInThePowderWeight[0].filedName;
          this.putInThePowderWeight.forEach((i) => {
            this.OfLiquidData.push(i.value);
          });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else if(this.totalWeightOfLiquid[0].filedKey == "DFXFDWD" && this.info.filedKey == "DFSFDWD"){
          this.filedName =  this.chartInfo.filedName+"/"+this.putInThePowderWeight[0].filedName;
          this.PowderWeightName =  this.info.filedName;
          this.OfLiquidName =  this.totalWeightOfLiquid[0].filedName;
          this.totalWeightOfLiquid.forEach((i) => {
            this.OfLiquidData.push(i.value);
          });
        if (this.OfLiquidData.length >= 6) {
          this.OfLiquidData.shift();
        }
      }else{
         this.filedName = this.chartInfo.filedName;
      }
    },
    // 柱形图加线性图
    barChart() {
      let chartId = this.chartIdList[this.info.chartId];
      this.chartIdList[this.info.chartId].clear;
      let xAxis = this.xAxis;
      let series = [
        {
          name: this.PowderWeightName,
          data: this.ranArr,
        },
        {
          name: this.OfLiquidName,
          data: this.OfLiquidData,
        },
      ];
      let barChartData = { chartId, xAxis, series };
      commonBarCharts(barChartData);
    },
    // 象形柱状图
    pictorialChart() {
      let chartId = this.chartIdList[this.info.chartId];
        let xAxis = this.xAxis;
       let series = {
        name: this.name,
        data: this.ranArr,
      };
      let pictorialChartData = { chartId, xAxis,series };
      pictorialCharts(pictorialChartData);
    },
    // 线型图
    lineChart() {
      let chartId = this.chartIdList[this.info.chartId];
      this.chartIdList[this.info.chartId].clear;
      let xAxis = this.xAxis;
      let series = {
        name: this.name,
        data: this.ranArr,
      };
      let lineChartData = { chartId, xAxis, series };
      commonLineCharts(lineChartData);
    },
    // 双线图
    doubleLineChart() {
      let chartId = this.chartIdList[this.info.chartId];
      this.chartIdList[this.info.chartId].clear;
      let xAxis = this.xAxis;
      let series = [
        {
          name: this.PowderWeightName,
          data: this.ranArr,
        },
        {
          name: this.OfLiquidName,
          data: this.OfLiquidData,
        },
      ];
      let doublelineChartData = { chartId, xAxis, series };
      doubleLineCharts(doublelineChartData);
    },
    // 雷达图
    radarChart() {
      let chartId = this.chartIdList[this.info.chartId];
      this.chartIdList[this.info.chartId].clear;
      let series = { name: "数据一", data: this.LdData};
      let radarChartData = { chartId, series };
      commonRadarCharts(radarChartData);
    },
    // 仪表盘
    gaugeChart() {
      let chartId = this.chartIdList[this.info.chartId];
      this.chartIdList[this.info.chartId].clear;
      let maxValue = this.info.maxValue;
      let minValue = this.info.minValue;
      let num = this.info.value;
      let filedUnit = this.info.filedUnit;//单位
      let series = { name: this.info.filedName };
      let gaugeChartData = { chartId, num, series,filedUnit,maxValue,minValue};
      commonGaugeCharts(gaugeChartData);
    },
    //消息滚动框
    // scrollChart(){
    //   let chartId = this.chartIdList[this.info.chartId];
    //   this.chartIdList[this.info.chartId].clear;
    //   let num = "40";
    //   let series = { name: this.name };
    //   let gaugeChartData = { chartId, num, series };
    //   commoscrollCharts(gaugeChartData);
    // }
  },
  watch: {
    handler(newValue, oldValue) {
      this.info = newValue;
    },
  },
  destroyed() {
    // 页面销毁前清除定时器
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
      //清除定时器
    if (this.getDataInterval) clearInterval(this.getDataInterval);
     this.xAxis = [];
     this.ranArr = [];
  },
};
</script>
<style lang="less" scoped>
.chart {
  width: 100%;
  height: 100%;

  .chart-head {
    width: 100%;
    height: 35px;
    background: url("./images/chart-title.png") no-repeat 0 0;
    background-size: 100% 100%;
    padding-left: 20px;
    font-size: 18px;
    font-family: TitleFamily;
    color: #ffffff;
    line-height: 38px;
    /* 文字不可选取 */
    // user-select: none;
  }

  .chart-cont {
    width: 100%;
    height: calc(100% - 36px);
    background: url("./images/chart-bg.png") no-repeat 0 0;
    background-size: 100% 100%;
    position: relative;

    .yName {
      position: absolute;
      top: 6px;
      left: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .chart-cont2 {
    width: 100%;
    height: calc(100% - 36px);
    background: url("./images/chart-bg.png") no-repeat 0 0;
    background-size: 100% 100%;
    padding: 4px 12px 14px;
    overflow: auto;
  }
}
</style>